/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-container[_ngcontent-%COMP%]{min-height:calc(100vh - 70px);background:var(--be-background-alternative);padding:25px;display:flex}form[_ngcontent-%COMP%]{background-color:var(--be-background);box-shadow:none;border:1px solid var(--be-divider-default);width:675px;max-width:100%;padding:25px;margin:auto}form[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:300;margin:0}form[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:5px 0 35px}"];
export { styles as styles };
